import { API } from "aws-amplify";
import { toast } from "react-toastify";

export const GET_SITE_PHOTOS_REQUEST = "@@photos/GET_SITE_PHOTOS_REQUEST";
export const GET_SITE_PHOTOS_SUCCESS = "@@photos/GET_SITE_PHOTOS_SUCCESS";
export const GET_SITE_PHOTOS_FAILURE = "@@photos/GET_SITE_PHOTOS_FAILURE";

export function getSiteInstalltionPhotos(siteId) {
    return async (dispatch) => {
        if (!siteId) return;
        dispatch({
            type: GET_SITE_PHOTOS_REQUEST,
        });
        try {
            const response = await API.get("cmsAPI", `/sites/${siteId}/photos`);
            dispatch({
                type: GET_SITE_PHOTOS_SUCCESS,
                payload: response,
            });
        } catch (error) {
            dispatch({
                type: GET_SITE_PHOTOS_FAILURE,
                payload: error,
            });
        }
    };
}

export const CLEAR_SITE_PHOTOS = "@@photos/CLEAR_SITE_PHOTOS";

export function clearSitePhotos() {
    return async (dispatch) => {
        dispatch({
            type: CLEAR_SITE_PHOTOS,
        });
    };
}

export const UPLOAD_INSTALLATION_PHOTO_REQUEST =
    "@@photos/UPLOAD_INSTALLATION_PHOTO_REQUEST";
export const UPLOAD_INSTALLATION_PHOTO_SUCCESS =
    "@@photos/UPLOAD_INSTALLATION_PHOTO_SUCCESS";
export const UPLOAD_INSTALLATION_PHOTO_FAILURE =
    "@@photos/UPLOAD_INSTALLATION_PHOTO_FAILURE";

export function uploadInstallationPhoto(siteId, subject, file) {
    return async (dispatch) => {
        dispatch({
            type: UPLOAD_INSTALLATION_PHOTO_REQUEST,
        });
        try {
            let fileName = file?.name;
            let fileExtension = fileName?.split(".").pop();
            const response = await API.get(
                "cmsAPI",
                `/sites/${siteId}/photo_upload_url?content_type=${file.type}&file_extension=.${fileExtension}&subject=${subject}`
            );

            if (response.upload_url && file) {
                const form = new FormData();
                let url = response.upload_url.url;
                Object.keys(response.upload_url.fields).forEach((it) => {
                    form.append(it, response.upload_url.fields[it]);
                });

                form.append("file", file);

                const requestOptions = {
                    method: "POST",
                    body: form,
                };
                const res = await fetch(url, requestOptions);

                if (!res.ok) {
                    const error = "Document upload failed";
                    toast.error(error);
                    throw new Error(error);
                }

                dispatch({
                    type: UPLOAD_INSTALLATION_PHOTO_SUCCESS,
                    payload: res,
                });
                // Wait for thumbnail to be generated
                await new Promise(resolve => setTimeout(resolve, 3000));
                return res;
            }

            return undefined;
        } catch (error) {
            dispatch({
                type: UPLOAD_INSTALLATION_PHOTO_FAILURE,
                payload: error,
            });

            return undefined;
        }
    };
}

export const DELETE_INSTALLATION_PHOTO_REQUEST =
    "@@photos/DELETE_INSTALLATION_PHOTO_REQUEST";
export const DELETE_INSTALLATION_PHOTO_SUCCESS =
    "@@photos/DELETE_INSTALLATION_PHOTO_SUCCESS";
export const DELETE_INSTALLATION_PHOTO_FAILURE =
    "@@photos/DELETE_INSTALLATION_PHOTO_FAILURE";

export function deleteInstallationPhoto(siteId, fileName) {
    return async (dispatch) => {
        dispatch({
            type: DELETE_INSTALLATION_PHOTO_REQUEST,
        });
        try {
            const response = await API.del(
                "cmsAPI",
                `/sites/${siteId}/photos/${fileName}`
            );
            dispatch({
                type: DELETE_INSTALLATION_PHOTO_SUCCESS,
                payload: response,
            });
            dispatch(getSiteInstalltionPhotos(siteId));
        } catch (error) {
            dispatch({
                type: DELETE_INSTALLATION_PHOTO_FAILURE,
                payload: error,
            });
        }
    };
}
